import { Feature, RoomCommands, RoomProperties } from '../../../projects/client';

export namespace InstallationFeaturesHelpers {
  export function constructInstallationFeatureUri(
    baseUri: string,
    featureName: string,
    gatewaySerial: string,
    installationId: number,
    deviceId?: string
  ): string {
    let uri = `${baseUri}/${installationId}/gateways/${gatewaySerial}`;

    if (deviceId) {
      uri += `/devices/${deviceId}/features/${featureName}`;
    } else {
      uri += `/features/${featureName}`;
    }

    return uri;
  }

  export function canRemoveRoom(room: Feature<RoomProperties, RoomCommands>): boolean {
    const hasActors = !!room?.properties?.actors?.value?.length;
    const hasChannels = !!room?.properties?.channels?.value?.length;

    return !!room?.commands?.remove?.isExecutable && !hasActors && !hasChannels;
  }

  export function canRemoveActorFromRoom(
    room: Feature<RoomProperties, RoomCommands>
  ): boolean {
    const removeActor = room?.commands?.removeActor;
  
    return !!removeActor?.isExecutable;
  }

  export function canAddActorToRoom(room: Feature<RoomProperties, RoomCommands>): boolean {
    return !!room?.isEnabled && !!room?.commands?.addActor?.isExecutable;
  }
}
